// Libraries
import { ReactNode } from 'react';

// Styles
import styles from './ChatMessages.module.css';

/**
 * @function ChatMessages
 * Container for list of chat messages
 *
 * @example
 * return (
 *   <ChatMessages></ChatMessages>
 * )
 */
function ChatMessages({ children }: ChatMessagesProps): JSX.Element {
    return <section className={`${styles.container}`}>{children}</section>;
}

/**
 * @interface ChatMessagesProps
 * Describes the properties required for the ChatMessages component
 *
 * @property {ReactNode}. children List of chat messages
 */
export interface ChatMessagesProps {
    children?: ReactNode;
}

// Exports
export default ChatMessages;
